import { TIMELINES } from 'src/components/navigation/navigation.js'

// The feed menu's groups: [{ key, title, manage?, items }]. The entries come
// from filter.js (lists, tags, bookmarks) and TIMELINES; manage is the route
// where the group is edited. Without bookmark folders, bookmarks stay among
// the timelines. A group with no entries shows only when it can be managed.
export const feedSections = ({
  timelines,
  lists,
  tags,
  bookmarks,
  loggedIn,
  bookmarkFolders,
}) => {
  const sections = [
    {
      key: 'timelines',
      title: 'nav.timelines',
      items: bookmarkFolders
        ? timelines.filter(({ name }) => name !== 'bookmarks')
        : timelines,
    },
  ]
  if (loggedIn) {
    sections.push(
      {
        key: 'lists',
        title: 'nav.lists',
        manage: { name: 'lists' },
        items: lists,
      },
      {
        key: 'tags',
        title: 'nav.hashtags',
        manage: { name: 'followed-tags' },
        items: tags,
      },
    )
    if (bookmarkFolders) {
      sections.push({
        key: 'bookmarks',
        title: 'nav.bookmarks',
        manage: { name: 'bookmark-folders' },
        items: bookmarks,
      })
    }
  }
  return sections.filter(({ items, manage }) => items.length || manage)
}

// feeds with a name of their own: how to find the name, and the icon and
// label to show while it is still loading
const NAMED_FEEDS = {
  'lists-timeline': {
    name: ({ id }, { listTitle }) => listTitle(id),
    loading: { icon: 'list', label: 'nav.lists' },
  },
  'bookmark-folder': {
    name: ({ id }, { folderName }) => folderName(id),
    loading: { icon: 'bookmark', label: 'nav.bookmarks' },
  },
  'tag-timeline': { name: ({ id }) => id },
  'instance-timeline': { name: ({ instance }) => instance },
}

// The feed a route shows, for the phone's feeds button: { route, icon, label }
// for a timeline, { route, iconLetter, labelRaw } for a list, hashtag,
// bookmark folder or instance; null on any other page (and before the
// router has a route). names looks up list titles and folder names.
export const currentFeed = ({ name, params = {}, query }, names) => {
  if (!name) return null
  const route = {
    name,
    params,
    ...(query && Object.keys(query).length && { query }),
  }
  const timeline = Object.values(TIMELINES).find((t) => t.route === name)
  if (timeline) return { route, icon: timeline.icon, label: timeline.label }
  const named = NAMED_FEEDS[name]
  if (!named) return null
  const labelRaw = named.name(params, names)
  if (!labelRaw) return { route, ...named.loading }
  const iconLetter = name === 'tag-timeline' ? '#' : labelRaw.slice(0, 1)
  return { route, iconLetter, labelRaw }
}

// The pinned feeds, in pin order: the entries of the feed menu's sections
// whose names are pinned. Pins that are no feed (chats) or are gone (a
// deleted list) are left out.
export const pinnedFeeds = (pinned, sections) => {
  const byName = new Map(
    sections.flatMap(({ items }) => items.map((item) => [item.name, item])),
  )
  return pinned.map((name) => byName.get(name)).filter(Boolean)
}
